module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3ef0cd49bed0b258662a012cde4725d6.gif";